


const Closeicon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path d="M4 4L16 16M16 4L4 16" stroke="currentColor" strokeWidth="1" strokeLinecap="square"/>
  </svg>
  )
}

export default Closeicon